<template>
  <ion-page>
    <master-layout pageTitle="اسکن بارکد سفارش">
      <ion-card>
      <ion-card-content v-if="!showData">
        <div style="display: none" id="loadingMessage">🎥 </div>
        <canvas id="order-canvas" width="100%" hidden></canvas>
      </ion-card-content>
      <ion-card-content v-if="showData">
        <h5>محصولات سفارش</h5>
        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr>
              <th>ردیف</th>
              <th>محصول</th>
              <th>ویژگی</th>
              <th>تعداد</th>
              <th>قیمت خرید</th>
              <th>جمع کل</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in items" :key="index">
              <td>
                <button @click="deleteItem(index)" type="button" class="btn btn-danger"><i
                    class="fas fa-times "></i></button>
                {{ index + 1 }}
              </td>
              <td>
                {{ item.product.title }}
              </td>
              <td>
                {{ item.attrObject?item.attrObject.str:'--' }}
              </td>
              <td>
                <input type="text" @keyup="setQuantity($event)" name="quantity" :data-index="index"
                       class="form-control quantity form-control-sm" v-model="item.quantity"
                       placeholder="تعداد...">
              </td>
              <td>
                <input type="text" @keyup="setBuyPrice($event)" :data-index="index" name="buy_price"
                       class="form-control [only_number] buy_price form-control-sm" v-model="item.buy_price"
                       placeholder="قیمت خرید...">
              </td>
              <td>
                <money :number="item.total"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="total-container">
          <table>
            <thead></thead>
            <tbody>
            <tr class="table-danger">
              <th>
                تعداد اقلام :
                <money :number="items.length"/>
              </th>
              <th>
                جمع قیمت خرید :
                <money :number="total_buy_price"/>
                تومان
              </th>
            </tr>
            </tbody>
          </table>
        </div>
        <ion-button color="success">افزودن محصولات سفارش به انبار</ion-button>
      </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>


<script>

// import MainPageItem from '/src/components/MainPageItem'
// import Money from '/src/components/Money'
import {
  IonCard,
  IonCardContent, IonPage, IonButton
} from "@ionic/vue";
import {mapActions} from "vuex";
import jsQR from '@/shared/jsQR'
import Money from "@/components/Money";
// import {openWebpage, showSystemNoti} from '@/shared/helper'


export default {
  components: {
    Money,
    IonCardContent, IonPage, IonButton,IonCard
  },
  mounted()
  {
    this.video = document.createElement("video");
    this.canvasElement = document.getElementById("order-canvas");
    this.canvas = this.canvasElement.getContext("2d");
    this.loadingMessage = document.getElementById("loadingMessage");
    this.outputMessage = document.getElementById("outputMessage");
    this.outputData = document.getElementById("outputData");
    this.open_camera();
  },
  data()
  {
    return {
      currentStream: false,
      video: false,
      canvasElement: false,
      canvas: false,
      loadingMessage: false,
      outputMessage: false,
      outputData: false,
      showData : false,
      items : []
    }
  }, async created()
  {
    const items = this.items;
    items.push(
        {
          product: {title : 'روغن'},
          product_id: 1,
          product_type: 'variable',
          quantity: 5,
          buy_price: 1000,
          attrItems: this.attrItems,
          attr: '',
          attrObject: {str : '1 لیتر'},
          total: 5000
        },
        {
          product: {title : 'فیلتر'},
          product_id: 1,
          product_type: 'variable',
          quantity: 5,
          buy_price: 1000,
          attrItems: this.attrItems,
          attr: '',
          attrObject: {str : 'بزرگ'},
          total: 5000
        },
        {
          product: {title : 'روغن موتور'},
          product_id: 1,
          product_type: 'variable',
          quantity: 5,
          buy_price: 1000,
          attrItems: this.attrItems,
          attr: '',
          attrObject: {str : '5 لیتر'},
          total: 5000
        },
        {
          product: {title : 'روغن'},
          product_id: 1,
          product_type: 'variable',
          quantity: 5,
          buy_price: 1000,
          attrItems: this.attrItems,
          attr: '',
          attrObject: {str : '6 لیتر'},
          total: 5000
        })
  },
  methods: {
    ...mapActions("app", {
      checkScanOrderQrCode: 'checkScanOrderQrCode',
    }),
    async tick()
    {
      const self = this;
      this.loadingMessage.innerText = "⌛ Loading video..."
      if (this.video.readyState === this.video.HAVE_ENOUGH_DATA)
      {
        this.loadingMessage.hidden = true;
        this.canvasElement.hidden = false;

        this.canvasElement.height = this.video.videoHeight;
        this.canvasElement.width = this.video.videoWidth;
        this.canvas.drawImage(this.video, 0, 0, this.canvasElement.width, this.canvasElement.height);
        var imageData = this.canvas.getImageData(0, 0, this.canvasElement.width, this.canvasElement.height);
        var code = jsQR(imageData.data, imageData.width, imageData.height, {
          inversionAttempts: "dontInvert",
        });
        if (code)
        {
          this.close_camera();
          // $('#camera_modal').modal('hide');
          const data = code.data;
          console.log(data)
          self.showData = true;
        }
        else
        {
          //
        }
      }
      requestAnimationFrame(this.tick);
    },
    open_camera()
    {
      // $('#camera_modal').modal('show');
      // $('#order-canvas').show();
      navigator.mediaDevices.getUserMedia({video: {facingMode: "environment"}}).then((stream)=>
      {
        this.currentStream = stream;
        this.video.srcObject = stream;
        this.video.setAttribute("playsinline", true); // required to tell iOS safari we don't want fullscreen
        this.video.play();
        requestAnimationFrame(this.tick);
      });
    },
    close_camera()
    {
      try
      {
        this.currentStream.getTracks().forEach(function (track)
        {
          if (track.readyState === 'live')
          {
            track.stop();
          }
        });
      } catch (e)
      {
        //
      }
      // window.$('#order-canvas').hide();
    },
    setQuantity: function (event)
    {
      const index = event.target.dataset.index;
      this.items[index].quantity = event.target.value;
      let n = Number(event.target.value);
      if (isNaN(n))
        n = 0;
      this.items[index].quantity = n;
      this.items[index].total = this.items[index].quantity * this.items[index].buy_price;
      this.setTotalBuyPrice();
    },
    setBuyPrice: function (event)
    {
      const index = event.target.dataset.index;
      let n = Number(event.target.value);
      if (isNaN(n))
        n = 0;
      this.items[index].buy_price = n;
      this.items[index].total = this.items[index].quantity * this.items[index].buy_price;
      this.setTotalBuyPrice();
    },
    setTotalBuyPrice: function ()
    {
      let t = 0;
      for (let i = 0; i < this.items.length; i++)
      {
        let n = 0;
        if (this.items[i].buy_price && this.items[i].quantity)
        {
          n = Number(this.items[i].buy_price * this.items[i].quantity)
        }
        t += n;
      }
      this.total_buy_price = t;
    },
    deleteItem: function (index)
    {
      this.items.splice(index, 1);
      this.setTotalBuyPrice();
    },
  },
  watch:{
    "$route.path":{
      handler(url)
      {
        if (url.indexOf('scanOrderQrcode')<0)
          this.close_camera();
        else
        {
          // window.$('#order-canvas').show();
          setTimeout(()=>{
            this.open_camera();
          },150)
        }
      }
    }
  }
};
</script>

<style scoped>
#order-canvas {
  width: 100%;
}
</style>